export default __webpack_public_path__ + "static/media/nftsarte.79082e53.png";